import { Outlet, useParams } from "react-router";

export function ProductsHandler(props){
    
    let param = useParams();
    return <Outlet {...props} params={param} />
}